import React from 'react'
//Service import
import service from "./services";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
import axios from "axios";

const commonImage = async (file,IsFPGUpload=false,FileLocation, url = '', fileName = '') => {
var bucket = {};
var params = {};
var options = {};
var streetparams;
const apiserve = new service();

if(FileLocation){
  streetparams = IsFPGUpload ? FileLocation.street + "/Program_Guide.pdf" : fileName ? FileLocation.street + "/" + fileName : FileLocation.street + "/" + Math.random().toString(36).substr(2, 9) + file.name
}else{
  streetparams = IsFPGUpload ? apiserve.formbucket.street + "/Program_Guide.pdf" : fileName ? apiserve.formaT.street + "/" + fileName : apiserve.formaT.street + "/" + Math.random().toString(36).substr(2, 9) + file.name
}

try {
  console.log('url',url, streetparams);
  
  const data = await axios.post(process.env.REACT_APP_SOCKET_API_KEY+'imageUpload', {'image':url,'key': streetparams})
  console.log(data,"data");
  return data.data.data.filelocation
} catch (error) {
  console.error('Error:', error);
}

        // AWS.config.update({
        //     accessKeyId: apiserve.DPro(apiserve.DPro(process.env.REACT_APP_AK_STAR)),
        //     secretAccessKey: apiserve.DPro(apiserve.DPro(process.env.REACT_APP_SK_WAR)),
        //     region:IsFPGUpload ? apiserve.formbucket.place : apiserve.formaT.place 
        //   });
        //   bucket = new AWS.S3({
        //     apiVersion: "2006-03-01",
        //     params: FileLocation ? {Bucket: FileLocation.location}  : { Bucket: apiserve.formaT.location },
        //   });
        //   params = {
        //     Key: streetparams,
        //     ContentType: file.type,
        //     Body: file,
        //   };
        //   AWS.config.httpOptions.timeout = 0;
        //   options = { partSize: 100 * 1024 * 1024, queueSize: 1 }
        //   return {bucket, params,options}
}    

export default commonImage